var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-chart-askue',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"styles":_vm.cssRules,"cssClasses":"chart box_shadow_initial pa-4 rounded-lg white"}})}
var staticRenderFns = []

export { render, staticRenderFns }